import { SkeletonLoader } from '@payaca/ambrosia';
import { FC } from 'react';

/**
 * Loading placeholder for the Proposal builder's right editor panel. Mirrors
 * the editor's default layout — header, financial summary bar, tab nav and
 * panel content — so the panel keeps its shape while the underlying queries
 * resolve, rather than popping in once ready.
 */
const ProposalEditorSkeleton: FC = () => {
  return (
    <div className="h-full flex flex-col" aria-hidden>
      {/* Header — reference, status badge, actions and the Next button. */}
      <div className="p-3.5 border-b flex justify-between items-center gap-2 flex-none">
        <div className="flex items-center gap-2 min-w-0">
          <SkeletonLoader.Title className="h-6 w-24" />
          <SkeletonLoader.Badge />
          <SkeletonLoader.Circle className="h-8 w-8 shrink-0" />
        </div>
        <SkeletonLoader className="h-9 w-20 rounded-lg shrink-0" />
      </div>

      <div className="overflow-hidden min-h-0 h-full flex flex-col">
        {/* Financial summary bar. */}
        <div className="px-3.5 py-5 border-b flex items-center justify-between gap-3 flex-none">
          <div className="flex items-center gap-2 min-w-0">
            <SkeletonLoader.Circle className="h-5 w-5 shrink-0" />
            <SkeletonLoader.Title className="w-40" />
          </div>
          <SkeletonLoader.Title className="h-6 w-24 shrink-0" />
        </div>

        {/* Tab nav pills. */}
        <div className="p-3.5 flex gap-3 flex-none">
          <SkeletonLoader className="h-8 w-24" />
          <SkeletonLoader className="h-8 w-20" />
          <SkeletonLoader className="h-8 w-24" />
          <SkeletonLoader className="h-8 w-20" />
        </div>

        {/* Tab panel content — representative item rows and actions. */}
        <div className="flex-1 min-h-0 px-3.5 space-y-2.5">
          <SkeletonLoader className="h-14 w-full rounded-lg" />
          <SkeletonLoader className="h-14 w-full rounded-lg" />
          <SkeletonLoader className="h-14 w-full rounded-lg" />
          <div className="pt-1 flex flex-col gap-2">
            <SkeletonLoader.Button className="h-9" />
            <SkeletonLoader.Button className="h-9" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProposalEditorSkeleton;
